import { render, staticRenderFns } from "./receiveForm.vue?vue&type=template&id=32a2c7ea&scoped=true&"
import script from "./receiveForm.vue?vue&type=script&lang=js&"
export * from "./receiveForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a2c7ea",
  null
  
)

export default component.exports